import React from 'react';
export const PartyPlant = () => (
  <svg width="201px" height="162px" viewBox="0 0 201 162" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-514.000000, -988.000000)">
        <g transform="translate(514.000000, 988.000000)">
          <path
            d="M148.569827,153.828286 L52.4303682,153.828286 L0.508570047,101.847549 C-0.169523349,101.168692 -0.169523349,100.057914 0.508570047,99.3790569 L99.2670336,0.508488428 C99.9459986,-0.169496143 101.054655,-0.169496143 101.732749,0.508488428 L200.492084,99.3790569 C201.169305,100.057914 201.169305,101.168692 200.492084,101.847549 L148.569827,153.828286 Z"
            fill="#F3F4F6"
            fillRule="nonzero"
          />
          <path
            d="M128.0625,157.0102 C128.0625,159.3202 121.3285,161.1922 113.0205,161.1922 C104.7135,161.1922 97.9785,159.3202 97.9785,157.0102 C97.9785,154.7002 104.7135,152.8272 113.0205,152.8272 C121.3285,152.8272 128.0625,154.7002 128.0625,157.0102"
            fill="#D0D7DA"
          />
          <g transform="translate(112.000000, 96.710000)">
            <path
              d="M11.1143,0.6185 C10.3323,-0.3095 5.9473,-0.2465 3.5243,1.7955 C1.1013,3.8365 0.1343,6.9875 1.5543,8.6735 C2.9743,10.3585 6.2443,9.9395 8.6673,7.8985 C11.0903,5.8565 11.8963,1.5465 11.1143,0.6185"
              fill="#CBD62A"
            />
            <path
              d="M11.1143,0.6185 C10.3323,-0.3095 5.9473,-0.2465 3.5243,1.7955 C1.1013,3.8365 0.1343,6.9875 1.5543,8.6735 C2.9743,10.3585 6.2443,9.9395 8.6673,7.8985 C11.0903,5.8565 11.8963,1.5465 11.1143,0.6185"
              stroke="#575825"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(101.000000, 101.710000)">
            <path
              d="M0.4883,1.4564 C-0.1277,2.5334 1.4753,6.7194 4.2863,8.3274 C7.0973,9.9354 10.4623,9.7554 11.5813,7.7994 C12.6993,5.8444 11.1473,2.8524 8.3363,1.2454 C5.5253,-0.3626 1.1043,0.3794 0.4883,1.4564"
              fill="#A3C23A"
            />
            <path
              d="M0.4883,1.4564 C-0.1277,2.5334 1.4753,6.7194 4.2863,8.3274 C7.0973,9.9354 10.4623,9.7554 11.5813,7.7994 C12.6993,5.8444 11.1473,2.8524 8.3363,1.2454 C5.5253,-0.3626 1.1043,0.3794 0.4883,1.4564"
              stroke="#575825"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(112.000000, 82.710000)">
            <path
              d="M8.0747,0.6849 C7.4627,0.0439 4.2677,0.2889 2.5947,1.8879 C0.9207,3.4859 0.3587,5.8279 1.4707,6.9919 C2.5817,8.1569 4.9477,7.7029 6.6207,6.1039 C8.2947,4.5049 8.6867,1.3269 8.0747,0.6849"
              fill="#CBD62A"
            />
            <path
              d="M8.0747,0.6849 C7.4627,0.0439 4.2677,0.2889 2.5947,1.8879 C0.9207,3.4859 0.3587,5.8279 1.4707,6.9919 C2.5817,8.1569 4.9477,7.7029 6.6207,6.1039 C8.2947,4.5049 8.6867,1.3269 8.0747,0.6849"
              stroke="#575825"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(102.000000, 87.710000)">
            <path
              d="M0.8682,0.9056 C0.1942,1.8026 1.1612,5.7406 3.5032,7.5006 C5.8452,9.2596 8.8862,9.4766 10.1102,7.8476 C11.3332,6.2176 10.2782,3.3596 7.9352,1.5996 C5.5932,-0.1594 1.5422,0.0086 0.8682,0.9056"
              fill="#A3C23A"
            />
            <path
              d="M0.8682,0.9056 C0.1942,1.8026 1.1612,5.7406 3.5032,7.5006 C5.8452,9.2596 8.8862,9.4766 10.1102,7.8476 C11.3332,6.2176 10.2782,3.3596 7.9352,1.5996 C5.5932,-0.1594 1.5422,0.0086 0.8682,0.9056"
              stroke="#575825"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(94.000000, 114.710000)">
            <path
              d="M0.0406,16.2064 L0.0406,29.4004 C0.0406,33.9814 2.9766,37.6954 6.5986,37.6954 L31.1896,37.6954 C34.8116,37.6954 37.7476,33.9814 37.7476,29.4004 L37.7476,0.2214 L0.0406,0.2214 L0.0406,9.2544"
              fill="#FFFFFF"
            />
            <path
              d="M0.0406,16.2064 L0.0406,29.4004 C0.0406,33.9814 2.9766,37.6954 6.5986,37.6954 L31.1896,37.6954 C34.8116,37.6954 37.7476,33.9814 37.7476,29.4004 L37.7476,0.2214 L0.0406,0.2214 L0.0406,9.2544"
              stroke="#7350A0"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M117.542,120.0776 L96.106,120.0776"
            stroke="#F2C217"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M129.9849,143.6801 C129.9849,147.8711 123.2029,150.2551 123.2029,150.2551 L123.2029,122.5491 L129.9849,122.5491 L129.9849,143.6801 Z"
            fill="#F2F3F3"
          />
          <path
            d="M129.9849,120.0776 L123.2029,120.0776"
            stroke="#F2C217"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M173.2462,152.8276 L141.5002,152.8276"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M54.4146,152.8276 L35.6586,152.8276"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M25.6587,152.8276 L17.6217,152.8276"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M129.9912,67.9369 L129.9882,69.5169"
            stroke="#D62793"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M129.9815,72.6772 L129.9785,74.2572"
            stroke="#D62793"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M133.1451,71.1029 L131.5651,71.0999"
            stroke="#D62793"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M128.4048,71.0942 L126.8238,71.0902"
            stroke="#D62793"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M80.7212,96.8764 L80.7182,98.4564"
            stroke="#F5C400"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M80.7119,101.6166 L80.7089,103.1966"
            stroke="#F5C400"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M83.8755,100.0424 L82.2945,100.0394"
            stroke="#F5C400"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M79.1348,100.0336 L77.5548,100.0296"
            stroke="#F5C400"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <g transform="translate(112.000000, 82.710000)">
            <path d="M0.8101,0.9594 L0.8101,31.3214" fill="#A3C23A" />
            <path
              d="M0.8101,0.9594 L0.8101,31.3214"
              stroke="#575825"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M126.0625,154.7953 C126.0625,155.3453 125.6125,155.7953 125.0625,155.7953 L100.9095,155.7953 C100.3585,155.7953 99.9095,155.3453 99.9095,154.7953 L99.9095,153.4053 C99.9095,152.8563 100.3585,152.4053 100.9095,152.4053 L125.0625,152.4053 C125.6125,152.4053 126.0625,152.8563 126.0625,153.4053 L126.0625,154.7953 Z"
            fill="#7350A0"
          />
          <path
            d="M184.7335,47.6586 C184.7335,30.1986 174.3145,16.0446 161.4625,16.0446 C148.6105,16.0446 138.1925,30.1986 138.1925,47.6586 C138.1925,64.9816 148.4495,79.0436 161.1625,79.2626 L159.2255,83.3936 L165.7115,83.3936 L163.6895,79.1256 C175.4965,77.6016 184.7335,64.0976 184.7335,47.6586"
            fill="#FFFFFF"
          />
          <path
            d="M184.7335,47.6586 C184.7335,30.1986 174.3145,16.0446 161.4625,16.0446 C148.6105,16.0446 138.1925,30.1986 138.1925,47.6586 C138.1925,64.9816 148.4495,79.0436 161.1625,79.2626 L159.2255,83.3936 L165.7115,83.3936 L163.6895,79.1256 C175.4965,77.6016 184.7335,64.0976 184.7335,47.6586 Z"
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M76.0503,131.974 C75.9923,131.974 75.9383,131.989 75.8813,131.991 C75.1823,128.817 72.3573,126.44 68.9723,126.44 C65.5763,126.44 62.7423,128.833 62.0563,132.025 C61.8883,132.008 61.7263,131.974 61.5533,131.974 C58.5863,131.974 56.1803,134.379 56.1803,137.347 C56.1803,140.315 58.5863,142.721 61.5533,142.721 L76.0503,142.721 C79.0183,142.721 81.4243,140.315 81.4243,137.347 C81.4243,134.379 79.0183,131.974 76.0503,131.974"
            fill="#FFFFFF"
          />
          <path
            d="M76.0503,131.974 C75.9923,131.974 75.9383,131.989 75.8813,131.991 C75.1823,128.817 72.3573,126.44 68.9723,126.44 C65.5763,126.44 62.7423,128.833 62.0563,132.025 C61.8883,132.008 61.7263,131.974 61.5533,131.974 C58.5863,131.974 56.1803,134.379 56.1803,137.347 C56.1803,140.315 58.5863,142.721 61.5533,142.721 L76.0503,142.721 C79.0183,142.721 81.4243,140.315 81.4243,137.347 C81.4243,134.379 79.0183,131.974 76.0503,131.974 Z"
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M162.4683,84.0668 L162.4683,150.2548"
            stroke="#DDE5E8"
            strokeLinecap="round"
          />
          <g transform="translate(49.000000, 42.710000)">
            <polyline
              fill="#FFFFFF"
              points="13.1709 2.9232 5.3759 12.4832 0.1789 0.8442"
            />
            <polyline
              stroke="#DDE5E8"
              strokeLinecap="round"
              strokeLinejoin="round"
              points="13.1709 2.9232 5.3759 12.4832 0.1789 0.8442"
            />
          </g>
          <g transform="translate(90.000000, 44.710000)">
            <polyline
              fill="#FFFFFF"
              points="0.2476 1.9857 8.4626 11.7307 13.3076 0.3867"
            />
            <polyline
              stroke="#DDE5E8"
              strokeLinecap="round"
              strokeLinejoin="round"
              points="0.2476 1.9857 8.4626 11.7307 13.3076 0.3867"
            />
          </g>
          <path
            d="M23.5586,33.5219 C81.8756,63.4239 140.1926,33.5219 140.1926,33.5219"
            stroke="#DDE5E8"
            strokeLinecap="round"
          />
          <polyline
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="29.0733 36.1742 31.1723 49.1992 42.1053 41.1442"
          />
          <polyline
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="69.8623 46.7211 76.5503 57.5721 83.0153 47.0671"
          />
          <polyline
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="112.1665 42.9945 121.5745 51.5945 124.9095 39.7185"
          />
          <g transform="translate(172.000000, 66.710000)">
            <path
              d="M2.2413,0.5756 C1.4683,1.8086 0.7393,2.7436 0.1673,3.4006"
              fill="#FFFFFF"
            />
            <path
              d="M2.2413,0.5756 C1.4683,1.8086 0.7393,2.7436 0.1673,3.4006"
              stroke="#DDE5E8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(169.000000, 24.710000)">
            <path
              d="M0.1949,0.1967 C0.1949,0.1967 10.2849,8.0287 10.2849,22.7987 C10.2849,29.8727 8.8289,35.1977 7.1379,38.9987"
              fill="#FFFFFF"
            />
            <path
              d="M0.1949,0.1967 C0.1949,0.1967 10.2849,8.0287 10.2849,22.7987 C10.2849,29.8727 8.8289,35.1977 7.1379,38.9987"
              stroke="#DDE5E8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <polygon
            stroke="#D62793"
            points="58.4346 82.0024 61.1156 88.2094 64.2076 86.7464 60.8636 81.2124"
          />
          <polygon
            stroke="#F2C217"
            points="81.8755 29.8139 84.5565 36.0209 87.6475 34.5579 84.3045 29.0239"
          />
          <polygon
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="96.4131 63.3637 92.9071 69.1447 95.8901 70.8177 98.4641 64.8857"
          />
          <polygon
            stroke="#0B9CE5"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="142.6978 98.2963 139.1928 104.0773 142.1758 105.7503 144.7498 99.8183"
          />
          <polygon
            fill="#FFFFFF"
            points="77.8296 152.934 59.7906 152.934 57.7656 140.748 79.8546 140.748"
          />
          <polygon
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="77.8296 152.934 59.7906 152.934 57.7656 140.748 79.8546 140.748"
          />
          <path
            d="M68.8101,141.0668 L68.8101,152.5268"
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M62.709,141.0668 L63.795,152.5268"
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M74.8892,141.0668 L73.8032,152.5268"
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M71.0401,126.4399 C71.0401,127.6709 70.0411,128.6689 68.8101,128.6689 C67.5791,128.6689 66.5811,127.6709 66.5811,126.4399 C66.5811,125.2089 67.5791,124.2109 68.8101,124.2109 C70.0411,124.2109 71.0401,125.2089 71.0401,126.4399"
            fill="#FFFFFF"
          />
          <path
            d="M71.0401,126.4399 C71.0401,127.6709 70.0411,128.6689 68.8101,128.6689 C67.5791,128.6689 66.5811,127.6709 66.5811,126.4399 C66.5811,125.2089 67.5791,124.2109 68.8101,124.2109 C70.0411,124.2109 71.0401,125.2089 71.0401,126.4399 Z"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M65.5147,131.7319 L66.9647,132.7289"
            stroke="#D62793"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M72.6275,135.7631 L73.8445,134.5801"
            stroke="#F5C400"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M62.2071,136.8061 L63.2521,138.1201"
            stroke="#F5C400"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M78.7451,138.5736 L78.1111,136.9426"
            stroke="#D62793"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </g>
  </svg>
);
